import styled from 'styled-components';
import { Input } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

// Search and filter components
const LtSearchBar = styled(Input.Search)`
	border: none;
`;

const FilterTagsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
	margin-left: 10px;
`;

const FilterTag = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 4px 10px;
	border-radius: 4px;
	background-color: #f0f5ff;
	color: #1890ff;
	font-size: 12px;
	font-weight: 500;
	border: 1px solid #d6e4ff;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
	margin: 0 2px;
`;

const ClearFilterButton = styled(CloseOutlined)`
	margin-left: 8px;
	color: #f56565;
	cursor: pointer;
	font-size: 14px;
	padding: 4px;
	border-radius: 50%;
	&:hover {
		background-color: #f4f4f4;
	}
`;

// Scroll components
const ScrollContainer = styled.div`
	position: relative;
	overflow-x: auto;
	white-space: nowrap;
	padding: 10px 0;
	scrollbar-width: none;
	-ms-overflow-style: none;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const ScrollButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 15px;
	margin-right: 10px;
`;

// Layout components
const ContentRow = styled.div`
	display: flex;
	margin-bottom: 24px;
	gap: 40px;
`;

const Column = styled.div`
	flex: 1;
`;

// Typography components
const SectionTitle = styled.div`
	color: #001529;
	font-weight: 600;
	font-size: 16px;
	margin-bottom: 16px;
	padding-bottom: 8px;
`;

const InfoItem = styled.div`
	margin-bottom: 12px;
	font-size: 14px;
	line-height: 1.5;
`;

const Label = styled.span`
	color: #646464;
	display: inline-block;
	margin-right: 8px;
`;

const Value = styled.span`
	color: #000000;
	font-weight: 500;
`;

export {
	LtSearchBar,
	FilterTagsContainer,
	FilterTag,
	ClearFilterButton,
	ScrollContainer,
	ScrollButtonContainer,
	ContentRow,
	Column,
	SectionTitle,
	InfoItem,
	Label,
	Value,
};
